function Settings() {
  return (
    <div>
      <h1>Settings</h1>
      <p>Welcome to Club OS Settings</p>
    </div>
  );
}

export default Settings;